// extracted by mini-css-extract-plugin
export const pagination = "T_X";